import ApplicationController from "./../application_controller"

export default class extends ApplicationController {

  connect() {
    super.connect()
  }

  assign(event) {
    this.stimulate("Admin::AttachmentReflex#assign", this.element)
  }

  submit(event) {
    event.preventDefault()
    this.stimulate("Admin::AttachmentReflex#update", this.element)
  }
}
